/**
 * Excel-style labels for survey work markers: A..Z, then AA, AB, ... ZZ, AAA, ...
 * @param {number} index zero-based equipment index
 * @returns {string}
 */
export function surveyWorkMarkerLabel (index) {
  const n = Number(index)
  if (!Number.isInteger(n) || n < 0) return ''
  let value = n + 1
  let label = ''
  while (value > 0) {
    value -= 1
    label = String.fromCharCode(65 + (value % 26)) + label
    value = Math.floor(value / 26)
  }
  return label
}



// WEBPACK FOOTER //
// ./src/lib/surveyWorkMarkerLabel.js